import PropTypes from 'prop-types';
import { FILTER_QUERY_PARAMS } from 'client/site-modules/shared/constants/lease-deals/lease-deals';

export const Deal = PropTypes.shape({
  id: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  term: PropTypes.number.isRequired,
  msrp: PropTypes.number.isRequired,
  dueAtSigning: PropTypes.number.isRequired,
  disclaimer: PropTypes.string,
  payment: PropTypes.number.isRequired,
  paymentRatio: PropTypes.number.isRequired,
  effectivePayment: PropTypes.number.isRequired,
  effectivePaymentRatio: PropTypes.number.isRequired,
  lifetimeCost: PropTypes.number,
  lifetimeCostRatio: PropTypes.number,
  bodyType: PropTypes.string,
  driveType: PropTypes.string,
  engineType: PropTypes.string,
  make: PropTypes.string.isRequired,
  makeNiceName: PropTypes.string.isRequired,
  mileageYearlyExcess: PropTypes.number,
  model: PropTypes.string.isRequired,
  modelNiceName: PropTypes.string.isRequired,
  seatingCapacity: PropTypes.number,
  styleId: PropTypes.number.isRequired,
  trim: PropTypes.string,
  trimNiceName: PropTypes.string,
  webUrls: PropTypes.string,
  year: PropTypes.number.isRequired,
  showCta: PropTypes.bool,
  paymentMedian: PropTypes.number,
  isGemDeal: PropTypes.bool.isRequired,
});

export const Deals = PropTypes.arrayOf(Deal);

export const SelectedFilters = PropTypes.shape({
  [FILTER_QUERY_PARAMS.BODY_TYPE]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.MONTHLY_PAYMENT]: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  [FILTER_QUERY_PARAMS.MAKE]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.ENGINE_TYPE]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.TERM]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.MILEAGE_ALLOWANCE]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.TOTAL_SEATING]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.DEALS]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.DUE_AT_SIGNING]: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  [FILTER_QUERY_PARAMS.PAGE_NUM]: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  [FILTER_QUERY_PARAMS.SORT_BY]: PropTypes.arrayOf(PropTypes.string),
  [FILTER_QUERY_PARAMS.ID]: PropTypes.arrayOf(PropTypes.string),
});

const LeaseDealsData = PropTypes.shape({
  topDealsByModelCount: PropTypes.number,
  deals: Deals,
});

export const LeaseDealsEntities = {
  LeaseDealsData,
  Deals,
  SelectedFilters,
};
